module.exports = __webpack_public_path__ + "img/electronic_electric_enabled_selected.f3eafb5c.svg";